<h1>404 : Page Not Found</h1>

<div class="content">
  <p>Sorry, but the page you are looking for cannot be found. Visit one of the links below for more information about GoArmy Edge.</p>
</div>

<div class="links">
  <a routerLink="/">Edge</a>
  <a routerLink="/football">Football</a>
  <a routerLink="/soccer">Soccer</a>
  <a routerLink="/support">Support</a>
  <a routerLink="/press">Press</a>
  <a href="//recruiter.goarmyedge.com/">Recruiter</a>
</div>
